import { Toast } from "primereact/toast";
import { createContext } from "react";

export const ToastContext: React.Context<React.RefObject<Toast>> =
  createContext(null as any);
